export function routes($stateProvider) {
    $stateProvider
        .state('app.susene.processes', {
        url: '/processos',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.susene.processes.details', {
        url: '/:id',
        template: require('./details/details.view.html'),
        controller: 'SusEneDetailProcessController',
        controllerAs: 'vm',
        role: ['suseneListarProcessos'],
        title: 'Detalhes de Processo'
    })
        .state('app.susene.processes.list', {
        url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Gestão de Processos',
        template: require('./directory/directory.view.html'),
        controller: 'SusEneDirectorySchedulingController',
        controllerAs: 'vm',
        role: ['suseneListarProcessos'],
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    });
}
routes.$inject = ['$stateProvider'];
